import { NumberField, numberFieldTemplate as template } from '@microsoft/fast-foundation';
import { inputFieldDefinition } from '../TextField/TextFieldBase';
import { NumberFieldComponent } from './NumberField';
export const numberFieldDefinition = Object.assign(Object.assign({}, inputFieldDefinition('number-field', template)), { baseClass: NumberField, shadowOptions: {
        delegatesFocus: true,
    } });
export const chameleonNumberField = NumberFieldComponent.compose(numberFieldDefinition);
